export default "/lock.70aafa3a1e69c469ff4a909d48014d32.svg";